// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-5cdc72a4]{padding:25px}.upload[data-v-5cdc72a4]{margin:25px;margin-bottom:0}.pagination[data-v-5cdc72a4]{width:100%;display:flex;justify-content:center;margin-top:50px}", ""]);
// Exports
module.exports = exports;
